/**
 * useClickOutside
 * Adds a click listener to close when click occurs outside the trigger and container.
 * Only attaches when `isOpen` is true.
 */
import { useEffect } from 'react'

export const useClickOutside = (
    triggerRef: React.RefObject<HTMLElement>,
    containerRef: React.RefObject<HTMLElement>,
    isOpen: null | string,
    onClose: () => void
): void => {
    useEffect(() => {
        if (!isOpen) return

        const handleClickOutside = (event: MouseEvent) => {
            const target = event.target as Node
            const clickedOnTrigger =
                triggerRef.current?.contains(target)

            const clickedOnContainer =
                containerRef.current?.contains(target)
            if (!clickedOnTrigger && !clickedOnContainer) {
                onClose()
            }
        }

        document.addEventListener('click', handleClickOutside, true)
        return () => document.removeEventListener('click', handleClickOutside, true)
    }, [isOpen, triggerRef, containerRef, onClose])
}

export default useClickOutside
